import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BannerState } from '../interfaces';

const BANNER_STATE_KEY = 'bannerState';

@Injectable()
export class PlatformEventService {
  constructor(private readonly apiService: ApiService) {}

  getPlatformEventInfo() {
    return this.apiService.httpGet(`/api/platformEvents`);
  }

  createPlatformEventInfo(event: any) {
    return this.apiService.httpPost(`/api/platformEvents`, event);
  }

  editPlatformEventInfo(event: any) {
    return this.apiService.httpPut(`/api/platformEvents/${event.id}`, event);
  }

  deletePlatformEventInfo(event: any) {
    return this.apiService.httpDelete(`/api/platformEvents/${event.id}`);
  }

  clearBannerState() {
    localStorage.removeItem(BANNER_STATE_KEY);
  }

  saveBannerState(state: BannerState) {
    localStorage.setItem(BANNER_STATE_KEY, JSON.stringify(state));
  }

  getBannerState(): BannerState {
    const bannerStateString = localStorage.getItem(BANNER_STATE_KEY);
    if (bannerStateString) {
      try {
        return JSON.parse(bannerStateString);
      } catch {
        return { hidden: false };
      }
    }
    return { hidden: false };
  }
}
